// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"ded06ce7","215":"c58d9d0f","375":"62d45a67","376":"53aa6c96","453":"8701dc61","711":"85b125ea","723":"b24ba25f"}[chunkId] + ".chunk.js";
};